import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "uni-radio-button",
  template: `
    <label
      class="radio-container"
      [class.is-checked]="checkedValue === value"
      [class.default]="styleVariant === 'default'"
      [class.modern]="styleVariant === 'modern'"
    >
      <ng-content></ng-content>

      <input
        type="radio"
        [name]="name"
        [value]="value"
        [checked]="checkedValue === value"
        (change)="onCheckedChange($event.target.value)"
        [disabled]="disabled"
      />
      <span class="checkmark"></span>
    </label>
  `,
  styleUrls: ["./radio-button.component.scss"],
})
export class RadioButtonComponent {
  @Input() public name: string;
  @Input() public value: any;
  @Input() public disabled: boolean;
  @Input() public styleVariant: "default" | "modern" = "default";

  private _checkedValue: string;

  @Input()
  public set checkedValue(value: string) {
    this._checkedValue = value;
  }

  public get checkedValue(): string {
    return this._checkedValue;
  }

  @Output() public checked = new EventEmitter<string>();

  public onCheckedChange(value: string): void {
    this.checked.emit(value);
  }
}
